import classnames from 'classnames';

import { Div } from './HTMLElement';
import { t } from './i18n/i18n';
import { RecommendedCartProductsProps } from './RecommendedCartProducts';
import { RecommendedCartProductTile } from './RecommendedCartProductTile';
import { Swiper } from './Swiper';
import { SwiperContext } from './SwiperContext';
import { useUpsellProducts } from './useUpsellProduct';

export const RecommendedCartProductsA = ({ classNames, limit }: RecommendedCartProductsProps) => {
  const { loading, products } = useUpsellProducts();
  return (
    <Div className={classnames('recommended-cart-products', classNames)}>
      <Div className="header" paddingY={2}>
        <h6 className="title">{t('cart.recommendedProducts.title')}</h6>
      </Div>
      {loading ? (
        'Stiamo analizzando dei prodotti consigliati per te'
      ) : (
        <>
          <SwiperContext>
            <Swiper
              breakpoints={{
                lg: {
                  direction: 'vertical',
                  enabled: false,
                  pagination: false,
                  slidesPerView: limit ?? 3,
                },
                xs: {
                  slidesPerView: 1,
                },
              }}
              pagination
              slides={products?.slice(0, limit).map((product) => (
                <RecommendedCartProductTile key={product.id} product={product} />
              ))}
              slidesPerView={1}
              spaceBetween={0}
            />
          </SwiperContext>
          {/* {products?.slice(0, limit).map((product) => (
            <Div className="content" key={product.id} uiClassName={{ bs5: 'bg-white border-bottom' }}>
              <RecommendedCartProductTile product={product} />
            </Div>
          ))} */}
        </>
      )}
    </Div>
  );
};
